import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3;

import styled from "../../styled-components";
export var RedocComponentWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  margin: 20px 0;\n  box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.34);\n"])));
export var OpenApiExampleWrap = styled(RedocComponentWrap)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  button {\n    color: #fff;\n  }\n"])));
export var CodeSampleWrap = styled(RedocComponentWrap)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose([""])));